<template>
  <!-- 테마 상품 swiper -->
  <div class="swiper-container thema_area divider">
    <swiper class="swiper-wrapper"
            :slides-per-view="1"
            :space-between="50"
            :pagination="{el: '#theme-banner-pagination', type: 'fraction'}"
            @imagesReady="$emit('loadThemeBannerImage')"
    >
      <template v-for="banner in themeBanners" :key="banner.bannerId">
        <swiper-slide class="swiper-slide thema_item">
          <div class="thema_bg">
            <img :src="banner.backgroundImageUrl" alt="" class="bg"><!-- [D] 배경 이미지 등록 -->
          </div>
          <div class="thema_tit_bx">
            <h2 class="thema_tit ellipsis" :style="{color: banner.fontColor}">{{banner.bannerText}}</h2>
            <p class="thema_txt ellipsis" :style="{color: banner.fontColor}">{{banner.bannerSubText}}</p>
          </div>
          <div class="thema_prod_bx">
            <ul class="thema_lst">
              <li class="thema_prod" v-for="product in banner.productList" :key="product.productId">
                <a @click.prevent="moveToProductDetail(product.productId)" href="#" class="thema_link">
                  <div class="thum_bx">
                    <img :src="product.productImageUrl" class="thum_img" alt="">
                  </div>
                  <div class="info_bx">
                    <div class="txt">{{product.productName}}</div>
                    <div class="price">{{product.commaSalePrice}}원</div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </swiper-slide>
      </template>
    </swiper>
    <!-- [D] swiper pagination -->
    <div class="pagination_area">
      <div class="swiper-pagination pagination" id="theme-banner-pagination"></div>
    </div>
  </div>
  <!-- //테마 상품 swiper -->
</template>

<script>
  import {defineComponent} from "vue";
  // import Swiper core and required modules
  import SwiperCore, {A11y, Navigation, Pagination, Scrollbar} from 'swiper';
  // Import Swiper Vue.js components
  import {Swiper, SwiperSlide} from 'swiper/vue';
  // Import Swiper styles
  import 'swiper/swiper.scss';
  import 'swiper/components/navigation/navigation.scss';
  import 'swiper/components/pagination/pagination.scss';
  import 'swiper/components/scrollbar/scrollbar.scss';
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  // install Swiper modules
  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

  export default defineComponent({
    name: 'theme-banner-component',
    props: ['themeBanners'],
    components: {
      Swiper,
      SwiperSlide,
    },
    methods: {
      moveToProductDetail(productId) {
        router.push(new NamedRouting('ProductDetailView', {productId: productId}));
      },
    },
  });
</script>